import cookie from 'cookie';

export default class CookieHelper {
    static get(key) {
        let cookies = this.getAll() || {};
        return cookies[key];
    }
    static getAll() {
        let cookies = cookie.parse(document.cookie);
        return cookies;
    }
    static set(key, value, options) {
       document.cookie = cookie.serialize(key, value, options);
    }
}